'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _decorators = require('../utils/propTypes/decorators');

var _UIModalDialog = require('./UIModalDialog');

var _UIModalDialog2 = _interopRequireDefault(_UIModalDialog);

var _UIModalPanel = require('./UIModalPanel');

var _UIModalPanel2 = _interopRequireDefault(_UIModalPanel);

var _ModalTransition = require('./internal/ModalTransition');

var _ModalTransition2 = _interopRequireDefault(_ModalTransition);

var _getTransitionProps = require('./internal/getTransitionProps');

var _getTransitionProps2 = _interopRequireDefault(_getTransitionProps);

var _EventRelay = require('../core/EventRelay');

var _Memoize = require('../core/Memoize');

var _DialogConstants = require('./DialogConstants');

var _AbstractModal = require('./internal/AbstractModal');

var _AbstractModal2 = _interopRequireDefault(_AbstractModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UIModal = function (_PureComponent) {
  _inherits(UIModal, _PureComponent);

  function UIModal(props) {
    _classCallCheck(this, UIModal);

    var _this = _possibleConstructorReturn(this, (UIModal.__proto__ || Object.getPrototypeOf(UIModal)).call(this, props));

    _this._closeStartRelay = (0, _EventRelay.makeEventRelay)();
    _this._openCompleteRelay = (0, _EventRelay.makeEventRelay)();
    _this._getTransitionProps = (0, _Memoize.memoizeLastResult)(_getTransitionProps2.default);
    return _this;
  }

  _createClass(UIModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          use = _props.use,
          rest = _objectWithoutProperties(_props, ['use']);

      if (use === 'sidebar') {
        return _react2.default.createElement(_UIModalPanel2.default, rest);
      }

      return _react2.default.createElement(_AbstractModal2.default, _extends({}, this.props, {
        componentName: 'UIModal',
        Transition: _ModalTransition2.default
      }));
    }
  }]);

  return UIModal;
}(_react.PureComponent);

UIModal.propTypes = _extends({}, _UIModalDialog2.default.propTypes, {
  ModalDialog: (0, _decorators.hidden)(_react.PropTypes.func),
  onCloseComplete: _react.PropTypes.func,
  onCloseStart: _react.PropTypes.func,
  onOpenComplete: _react.PropTypes.func,
  onOpenStart: _react.PropTypes.func,
  use: _react.PropTypes.oneOf(Object.keys(_DialogConstants.MODAL_USE_CLASSES)).isRequired,
  _contextual: _react.PropTypes.bool
});

UIModal.defaultProps = _extends({}, _UIModalDialog2.default.defaultProps, {
  ModalDialog: _UIModalDialog2.default,
  _contextual: false
});

UIModal.displayName = 'UIModal';

exports.default = UIModal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/dialog/UIModal.js
// module id = 48
// module chunks = 3 4 5